import { runtimeEnv } from "config/runtimeEnv";
import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";

let env = runtimeEnv("B2B_API_BASE_URL");

export const getBookingListService = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  const { search, dateFrom, dateTo, pageSize, status, companyId } = data;

  // Build the URL based on the provided parameters
  let url = `${env}${API_ENDPOINT.Reservation.getAPI}?isB2B=true&bookingType=1&search=${search}&page=${page}&status=${status}&pageSize=${pageSize}&companyTrips=true`;
  if (dateFrom && dateFrom?.length > 0) {
    url += `&dateFrom=${dateFrom}`;
  }
  if (dateTo && dateTo?.length > 0) {
    url += `&dateTo=${dateTo}`;
  }
  if (companyId) {
    url += `&companyId=${companyId}`;
  }

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getBookingDetailsService = async (payload) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.Reservation.getAPI}/${payload}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const addBookingService = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Reservation.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateBookingService = async (payload) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Reservation.api}/${payload?.tripId}`, payload?.bookingData)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getCancelReasonService = async () => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.Reservation.cancelReasonApi}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getBookingBufferTimeService = async (payload) => {
  const res = await requestInstance
  .get(`${env}${API_ENDPOINT.Reservation.bufferTimeApi}/?type=${payload?.type}`)
  .catch((err) => err.response);
  return setCurrentUser(res);
}

export const getCompanyCityService = async (payload) => {
  const res = await requestInstance
  .get(`${env}${API_ENDPOINT.Reservation.companyCity}?contractId=${payload?.contractId}`)
  .catch((err) => err.response);
  return setCurrentUser(res);
}

export const getCompanyServiceService = async (payload) => {
  const res = await requestInstance
  .get(`${env}${API_ENDPOINT.Reservation.companyService}?contractId=${payload?.contractId}&location=${payload?.location}`)
  .catch((err) => err.response);
  return setCurrentUser(res);
}

export const getAirportTerminalListService = async (payload) => {
  const res = await requestInstance
  .get(`${env}${API_ENDPOINT.Reservation.bufferTimeApi}/?type=${payload?.type}&sourceAddress=${payload?.sourceAddress}`)
  .catch((err) => err.response);
  return setCurrentUser(res);
};

export const requestExtensionService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Reservation.extensionRequestApi}/${payload?.tripId}`, payload?.extensionData)
    .catch((err) => err.response);
  return setCurrentUser(res);
};